import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "ユーザーが手続きを行うきっかけになる事象を記述します。",
  "例: 苗字が変わったとき",
];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureTriggerInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError = false,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="トリガー" />
      <InputNoticeList notices={notices} />
      <SimpleTextInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
        maxLength={getMaxLength("procTrigger")}
      />
    </div>
  );
};
